import Vue from 'vue'
import Router from 'vue-router'
// import health from '../components/health/router'
import index from '../components/index/router'
import my from './my.js'
import service from '../components/service/router'
import bindAccount from '../components/bindAccount/router'
import scanBind from '../components/scanBind/router'
import blankPage from '../components/blankPage.vue'
// import internetTerms from '../components/internetTerms'
// import download from '../page/download.vue'
import hospital from "./hos"
import team from './team'
import coupons from './coupons'
import doc from './doc'
import news from './news'
import account from './account'
import report from './report'
import active from './active'
import consult from './consult'
import article from './article'
//排队叫号
import medical from './medical'
//费用查询
import fee from './fee'
//日间手术
import DaySurgery from '../page/daysurgery/daysurgery'
//肿瘤示范病房
import Tumour from './tumour'
//病历复印
import Copymedical from './copymedical'
//预约挂号
import Book from './book'
//用药查询
import Medication from './medicationquery'
//复诊续方
import Renewal from '../page/renewal/renewal'
//就诊查询
import Query from './query'
//住院管家
import Butler from './butler'
//满意度问卷调查
import Questionnaire from "./questionnaire";
//新冠检测
import Ncp from './ncp'
//投诉建议
import Feedback from './feedback'
//健康宣教
import He from './he'
//入院办理
import Admission from '../page/admission/admission'
//检查须知
import Jcxz from '../page/jcxz/router'
//药品科普
import Ypkp from '../page/ypkp/router'
//排队叫号
import Pdjh from '../page/pdjh/router'
//住院患者筛查表
import Zyhzscb from '../page/zyhzscb/router'
//胃肠专区
import Wczq from '../page/wczq/router'
//新版首页
import V2 from '../page/v2/router'
//用药咨询
import Yyzx from '../page/yyzx/router'
//群聊
import Group from '../page/group/router'
//护理中心
import Zkhl from '../page/zkhl/route'
// 校医院
import School from '../page/school/router'
//年度报告
import R2021 from '../page/2021/route'
//年度报告
import R2022 from '../page/2022/route'
//年度报告
import R2023 from '../page/2023/route'
//陪护证
import Peihu from '../page/peihu/route'
//患者筛查表
import {hzscbRoute} from "@/page/hzscb/route";
//乳腺中心
import {rxzxRouter} from "@/page/rxzx/router";
//康复中心
import {kfzxRouter} from "@/page/kfzx/router";
//等候入院
import {dhryRoute} from "@/page/dhry/dhryRoute";
//手术进展
import {ssjzRoute} from "@/page/ssjz/ssjzRoute";
// IBD
import ibdRoute from "@/page/ibd/ibdRoute";
//检查预约
import JcyyRoute from "@/page/jcyy/jcyyRoute";
//功能社区
import GnsqRoute from "@/page/gnsq/gnsqRoute";
import {redirect404} from "@/utils/redirect404";
//内镜中心
import {EndoscopyRoute} from "@/page/endoscopy/route";
//国际医学部
import Gjyxb from '@/page/gjyxb/router'
//整形外科中心
import {zxwkzxRouter} from "@/page/zxwkzx/router";
// 泛血管健康管理
import {FxgjkglRouter} from "@/page/fxgjkgl/router";

Vue.use(Router)


export const DEFAULT_INDEX = '/v3/index'
const router = new Router({
  routes: [
    {
      path: "/",
      redirect: to => {
        const {action, ...query} = url("?");
        if (action === 'toBookDeptPage') { // 预约挂号科室排班页
          return {
            path: '/book/book/expert',
            query: {
              bookDeptId: query.bookDeptId,
              bookHosId: query.bookHosId,
              bookSort: '预约挂号'
            }
          }
        }

        if (action === 'toBookDocPage') { // 预约挂号医生排班页
          return {
            path: '/book/doc/' + query.bookDocId,
            query: {
              bookDocId: query.bookDocId,
              bookHosId: query.bookHosId,
              bookSort: '预约挂号'
            }
          }
        }

        // 默认
        return {
          path: '/index'
        }
      }
    },
    {
      path: "/404",
      // redirect: DEFAULT_INDEX,
      component: () => import('../404')
    },
    {
      path: "/home",
      redirect: DEFAULT_INDEX,
      //component: () => import('../page/home')
    },
    {
      path: "/index",
      redirect: DEFAULT_INDEX,
      //component: () => import('../page/index')
    },
    {
      path: "/index/all",
      redirect: redirect404
      // component: () => import('../page/index/all')
    },
    {
      path: "/search",
      component: () => import('../page/search')
    },
    {
      path: "/promote",
      component: () => import('../page/promote')
    },
    {
      path: "/download/:type",
      redirect: redirect404,
      // component: download
    },
    //马甲二维码
    {
      path: "/products",
      component: () => import('../page/products')
    },
    {
      path: "/blankPage/:id",
      component: blankPage
    },
    {
      path: "/profile",
      redirect: '/v2/my',
      // component: () => import('../page/profile')
    },
    {
      path: "/internetTerms",
      redirect: to => `/404?path=${to.fullPath}`
      // component: internetTerms
    },
    {
      path: "/feedback",
      redirect: '/feedback/submit',
      // component: () => import('../page/feedback')
    },
    /**
     * 药事服务中转页
     * @query.compatId
     * @query.userId
     * @query.code
     */
    {
      path: '/prescription',
      component: () => import('../page/prescription')
    },
    /**
     * 新冠病毒智能评估
     */
    {
      path: '/wuhan',
      component: () => import('../page/wuhan')
    },
    /**
     * 床位安排通知
     */
    {
      path: '/notice/chuang',
      component: () => import('../page/notice/chuang')
    },
    {
      path: '/directPay',
      component: () => import('../page/DirectPay')
    },
    // 图聚hisDeptId转deptId
    {
      path: '/AppDeptInfo',
      component: () => import('../page/AppDeptInfo')
    },
    ...index,
    ...my,
    ...bindAccount,
    ...service,
    //...health,
    ...scanBind,
    ...hospital,
    ...team,
    ...coupons,
    ...doc,
    ...news,
    ...account,
    ...report,
    ...active,
    ...consult,
    ...article,
    ...medical,
    ...fee,
    ...DaySurgery,
    ...Tumour,
    ...Copymedical,
    ...Book,
    ...Medication,
    ...Renewal,
    ...Query,
    ...Butler,
    ...Questionnaire,
    ...Ncp,
    ...Feedback,
    ...He,
    ...Admission,
    ...Jcxz,
    ...Ypkp,
    ...Pdjh,
    ...Zyhzscb,
    ...Wczq,
    ...V2,
    ...Yyzx,
    ...Group,
    ...Zkhl,
    ...School,
    ...R2021,
    ...R2022,
    ...R2023,
    ...Peihu,
    ...hzscbRoute,
    ...rxzxRouter,
    ...kfzxRouter,
    ...dhryRoute,
    ...ssjzRoute,
    ...ibdRoute,
    ...JcyyRoute,
    ...GnsqRoute,
    ...EndoscopyRoute,
    ...Gjyxb,
    ...zxwkzxRouter,
    ...FxgjkglRouter
  ]
})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js